<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`检测项目详情`"
    width="900px"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" disabled :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="检测项目" prop="sampleName">
            <el-input v-model.trim="editForm.sampleName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模版编号" prop="sampleCode">
            <el-input v-model.trim="editForm.sampleCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="报告名称" prop="sampleBelong">
            <el-input v-model.trim="editForm.sampleBelong" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测依据">
            <el-table border :data="basisList" height="300" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
              <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
              <el-table-column prop="basisName" label="依据的标准名称及编号（含年号）" header-align="center"></el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测设备">
            <el-table border :data="deviceList" height="300" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
              <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
              <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
              <el-table-column prop="devCode" label="设备编号" align="center"></el-table-column>
              <el-table-column prop="nxCheckTime" label="有效日期" align="center"></el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getSample, getItem } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {},
      itemList: [],
      basisList: [],
      deviceList: [],
      rules: {
        sampleName: [{ required: true, message: '请输入检测项目', trigger: 'blur' }],
        sampleCode: [{ required: true, message: '请输入模版编码', trigger: 'blur' }],
        sampleBelong: [{ required: true, message: '请输入报告名称', trigger: 'blur' }]
      },
      basisVisible: false,
      deviceVisible: false,
      activeBasisId: null
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getSample({ id: this.activeId });

        this.editForm = {
          id: data.id,
          sampleName: data.sampleName,
          sampleCode: data.sampleCode,
          unitPrice: data.unitPrice,
          checkPeriod: data.checkPeriod,
          oriVersion: data.oriVersion,
          etmtType: data.etmtType,
          sampleType: data.sampleType,
          type: data.type,
          sampleBelong: data.sampleBelong,
          cate: data.cate,
          remark: data.remark
        };
        this.itemList = data.itemList ?? [];
        this.deviceList = data.deviceList ?? [];
        this.getBasisList();
      } finally {
        this.detailLoading = false;
      }
    },
    // 获取检测项目下检测依据列表
    async getBasisList() {
      const promises = this.itemList.map(async item => {
        const { data } = await getItem({ id: item.itemId });
        return data.basisList ?? [];
      });

      const returnAll = await Promise.all(promises);
      let basisList = [];
      returnAll.map(item => basisList.push(...item));
      this.basisList = basisList.sort((a, b) => a.remark - b.remark);
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
